import { createMachine } from "xstate";
import { patchScanEsimQRCode } from "@nju/data-access-dev-tip";

interface IContext {
  iccId: string;
}

type IEvent =
  | {
      type: "SCAN_QR";
    }
  | {
      type: "SCAN_QR_SUCCESS";
    }
  | {
      type: "SCAN_QR_ERROR";
    };

export const scanEsimQRCodeMachine = createMachine<IContext, IEvent>(
  {
    schema: {
      context: {} as IContext,
      events: {} as IEvent,
    },
    initial: "init",
    states: {
      init: {
        on: {
          SCAN_QR: {
            target: "scanQRCode",
          },
        },
      },
      scanQRCode: {
        invoke: {
          src: "scanQRCode",
        },
        on: {
          SCAN_QR_SUCCESS: {
            target: "success",
          },
          SCAN_QR_ERROR: {
            target: "error",
          },
        },
      },
      success: {
        type: "final",
      },
      error: {
        type: "final",
      },
    },
  },
  {
    services: {
      scanQRCode: ({ iccId }) => {
        return async (callback) => {
          try {
            await patchScanEsimQRCode({ iccId });

            callback({
              type: "SCAN_QR_SUCCESS",
            });
          } catch {
            callback({
              type: "SCAN_QR_ERROR",
            });
          }
        };
      },
    },
  },
);
